import { useEffect, useRef } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../i18n/LangContext";
import { api } from "../api/client";

// Backend is authoritative for authenticated users: adopt preferred_language on login,
// then persist any later switch back to the account.
export function LangSync() {
  const { user } = useAuth();
  const { lang, setLang } = useLang();
  const adopted = useRef(null);

  useEffect(() => {
    if (!user?.user_id) {
      adopted.current = null;
      return;
    }
    if (adopted.current !== user.user_id) {
      adopted.current = user.user_id;
      if (user.preferred_language && user.preferred_language !== lang) setLang(user.preferred_language);
      return;
    }
    if (user.preferred_language !== lang) {
      api.patch("/users/me", { preferred_language: lang }).catch(() => {});
    }
  }, [user, lang, setLang]);

  return null;
}
